import gql from 'graphql-tag';

export const getProductCategoryQuery = gql(/* GraphQL */ `
  query getProductCategory(
    $getProductCategoryRequest: GetProductCategoryRequest!
  ) {
    getProductCategory(getProductCategoryRequest: $getProductCategoryRequest) {
      productCategory {
        productCategoryId
        name
        description
        productType
        groupId
        groupType
      }
    }
  }
`);
